// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: Agents in Settings → Connections (design/agents-machine-settings A, JP 2026-11-04): the
// machine list, then a page per machine, each taking over the whole tab. MobileSettingsView reads
// this for the header title and sends Back here first, as for the phone Notifications pages.

import {makeAutoObservable} from 'mobx';

class AgentSettingsPage {
	isOpen = false;
	/** The machine whose page is open; null for the list. */
	machineId: string | null = null;

	constructor() {
		makeAutoObservable(this);
	}

	/** Opens the list, or a machine's page straight away. */
	open(machineId: string | null = null): void {
		this.isOpen = true;
		this.machineId = machineId;
	}

	/** One level up: a machine's page to the list, the list to Connections. */
	back(): void {
		if (this.machineId !== null) this.machineId = null;
		else this.isOpen = false;
	}

	close(): void {
		this.isOpen = false;
		this.machineId = null;
	}
}

export default new AgentSettingsPage();
